export default __webpack_public_path__ + "static/peopleGroup-1ec3e9df52c26950f3fb4bbef5b060a1.png";